/**
 * Question-chooser — public API.
 *
 * @module gibbs/question-chooser
 */

export { FRAMES, getFrameById, isEscapeFrame } from './frames';

export {
    getActiveFrameId,
    getActiveFrame,
    setActiveFrame,
    clearActiveFrame,
} from './activeFrameState';

export {
    COLUMN_IDS,
    getFrameEmphasis,
    getFrameEmphasisFor,
} from './frameEmphasis';
